//验证是否外部地址
export function isExternal(path) {
    return /^(https?:|mailto:|tel:)/.test(path)
}
export function isTel(t) {
    return  /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(t)
}
//

export function validUsername(str) {
    // const valid_map = ['admin', 'editor']
    // return valid_map.indexOf(str.trim()) >= 0

    if (str.trim()) {
        return true
    } else {
        return false
    }
}

export function validURL(url) {
    const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
    return reg.test(url)
}

export function validLowerCase(str) {
    const reg = /^[a-z]+$/
    return reg.test(str)
}

export function validUpperCase(str) {
    const reg = /^[A-Z]+$/
    return reg.test(str)
}

export function validAlphabets(str) {
    const reg = /^[A-Za-z]+$/
    return reg.test(str)
}

export function validEmail(email) {
    const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return reg.test(email)
}

export function isString(str) {
    if (typeof str === 'string' || str instanceof String) {
        return true
    }
    return false
}

export function isArray(arg) {
    if (typeof Array.isArray === 'undefined') {
        return Object.prototype.toString.call(arg) === '[object Array]'
    }
    return Array.isArray(arg)
}

export function isNumber(value) {
    var regPos = /^\d+(\.\d+)?$/; //非负浮点数
    var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
    if (regPos.test(value) || regNeg.test(value)) {
        return true;
    } else {
        return false;
    }
}

/**
 * 是否正整数
 * @param {*} value 数据
 */
export function isPositiveInteger(value) {
    var reg = /^[1-9][0-9]*$/;
    if (reg.test(value)) {
        return true;
    } else {
        return false;
    }
}

/**
 * 验证密码（必须包含字母和数字，长度6-16位）
 * @param {*} value 数据
 */
export function validPassword(value) {
    var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z\W]{6,18}$/;
    if (reg.test(value)) {
        return true;
    } else {
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/utils/validate.js